import React, { Component } from 'react';
import { Button, Dialog } from '@material-ui/core';
import { Logout } from '@mui/icons-material';

class CheckLogoutDialog extends Component {
  state={ open: true }
  renderCheckDialog=() => {
    const { onCancel, onCheck } = this.props;
    return (
      <div style={{ width: 515, height: 458, backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Logout style={{ marginTop: 32, width: '162', height: '185', color: '#5A397E' }} />
        <div style={{ marginTop: 32, fontSize: 25 }}>確定要登出嗎？</div>
        <div style={{ marginTop: 32, display: 'flex' }}>
          <Button style={{ height: 47, width: 165, backgroundColor: '#B8B8B8', color: 'white', borderRadius: 8, marginRight: 16 }} onClick={onCancel}>取消</Button>
          <Button style={{ height: 47, width: 165, backgroundColor: '#66D4DB', color: 'white', borderRadius: 8 }} onClick={onCheck}>確認</Button>
        </div>
      </div>
    );
  }

  render () {
    const { open } = this.props;
    return (
      <Dialog
        PaperComponent={ this.renderCheckDialog}
        open={open}
      />
    );
  }
}

export default CheckLogoutDialog;
